@if(displayedColumns.length) {
<div class="table-main">
<div class="table-header">
  @if (showSearch) {
  <div class="table-header__left">
    <input type="text" class="input-sm" [placeholder]="'searchPlaceholder' | translate" (keyup)="applyFilter($event)"
      #input />
  </div>
  }
  <div class="table-header__right">
    @if(showRefresh) {
    <button mat-icon-button color="primary" [matTooltip]="'refreshTableTooltip' | translate" (click)="refreshTableData()">
      <mat-icon>refresh</mat-icon>
    </button>
    }
    <ng-content select="[header-right]"></ng-content>
  </div>
</div>

<div class="table-container"
  [class.table-container--reorderable]="enableRowReorder"
  cdkDropList
  cdkDropListOrientation="vertical"
  [cdkDropListDisabled]="!enableRowReorder"
  [cdkDropListData]="dataSource.data"
  (cdkDropListDropped)="onRowReorderDrop($event)">
  <table mat-table [dataSource]="dataSource" matSort [matSortActive]="activeSortColumnDef || defaultSortColumnDef" multiTemplateDataRows
    [matSortDirection]="activeSortDirection || defaultSortDirection">
    @if(showOrderColumn) {
    <ng-container matColumnDef="reorder">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table-reorder-cell table-reorder-cell--header table-reorder-cell--static">
          <span class="table-header-text">{{ 'orderNumber' | translate }}</span>
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="mat-column-reorder-cell"
        [ngClass]="{'border-bottom-none': showExpandedRows && expandedElement === row}">
        <span
          class="table-reorder-cell"
          [class.table-reorder-cell--static]="!enableRowReorder"
          [matTooltip]="enableRowReorder ? ('dragToReorder' | translate) : ''"
          [matTooltipDisabled]="!enableRowReorder"
          matTooltipShowDelay="200">
          @if (enableRowReorder) {
            <mat-icon class="table-reorder-handle" aria-hidden="true">drag_indicator</mat-icon>
          }
          <span class="table-order-number">{{ row.order }}</span>
        </span>
      </td>
    </ng-container>
    }
    @if(showExpandedRows) {
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row"
        [ngClass]="{'border-bottom-none': showExpandedRows && expandedElement === row}">
        <mat-icon class="clickable" (click)="expandedElement = expandedElement === row ? null : row">{{expandedElement
          === row ?
          'expand_less' : 'expand_more'}}</mat-icon>
      </td>
    </ng-container>
    }
    @for (column of columns; track column) {
    <ng-container [matColumnDef]="column.columnDef">
      @if(column.isSortable ?? true) {
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class="table-header-text">{{ column.header | translate }}</span>
        @if(column.required) { <span class="required-asterisk">*</span> }
      </th>
      } @else {
      <th mat-header-cell *matHeaderCellDef>
        <span class="table-header-text">{{ column.header | translate }}</span>
        @if(column.required) { <span class="required-asterisk">*</span> }
      </th>
      }

      <td mat-cell *matCellDef="let row; let i = dataIndex" [attr.data-label]="column.header"
        [ngClass]="{'border-bottom-none': showExpandedRows && expandedElement === row}">
        @if(column.isToggle) {
        @if(column.isLoading && column.isLoading(row)) {
        <mat-spinner [strokeWidth]="3" [diameter]="24" color="primary"></mat-spinner>
        } @else {
        <mat-slide-toggle [checked]="row[column.columnDef]"
          (change)="column.onToggle ? column.onToggle(row, $event) : ''"
          [disabled]="column.isDisabled && column.isDisabled(row)" color="primary"></mat-slide-toggle>
        }
        } @else if(column.isEditable) {
        <kzn-table-dynamic-input [type]="column.inputType" [label]="column.header" [required]="column.required ?? true"
          [readOnly]="column.readOnly ?? false"
          [options]="resolveColumnDropdownOptions(column, row)"
          [optionLabels]="column.optionLabels ?? null"
          [placeholder]="column.placeholder ?? null"
          [selectPlaceholder]="column.selectPlaceholder ?? null"
          [searchPlaceholder]="column.searchPlaceholder ?? null"
          [value]="row[column.columnDef]"
          [stopDragOnControls]="enableRowReorder"
          (onTableDynamicInputValueUpdate)="onTableDynamicInputValueUpdate($event, column.columnDef, row)"></kzn-table-dynamic-input>
        } @else if(column.stackedCell) {
        @let stacked = column.stackedCell(row, i);
        <div class="table-cell-stacked">
          <span class="table-cell-stacked__primary">{{ stacked.primary }}</span>
          @if (stacked.secondary) {
          <span class="table-cell-stacked__secondary">{{ stacked.secondary }}</span>
          }
        </div>
        }
        @else {
        <pre>{{ column.cell ? column.cell(row, i) : row[column.columnDef] }}</pre>
        }
      </td>
    </ng-container>
    }

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>{{ actionColumnHeader | translate }}</th>
      <td mat-cell *matCellDef="let row" [attr.data-label]="actionColumnHeader | translate"
        [ngClass]="{'border-bottom-none': showExpandedRows && expandedElement === row}">
        <div class="table-column-actions-wrapper" (mousedown)="$event.stopPropagation()">
          @for (action of rowActions; track $index) {
          @if(action.isLoading && action.isLoading(row)) {
          <mat-spinner [strokeWidth]="3" [diameter]="24"
            [color]="action.color"></mat-spinner>
          } @else {
          <span
            class="table-action-item"
            [class.table-action-item--disabled]="action.isDisabled && action.isDisabled(row)"
            [matTooltip]="getActionTooltip(action, row)"
            [matTooltipPosition]="action.tooltipPosition ?? 'above'"
            matTooltipShowDelay="200">
            <button
              mat-icon-button
              [color]="action.color"
              (click)="onActionClick(action, row)"
              [attr.aria-label]="action.title | translate"
              [disabled]="action.isDisabled && action.isDisabled(row)">
              @if (action.imgIcon) {
              <img [src]="action.imgIcon" alt="" class="table-action-icon-img" />
              } @else {
              <mat-icon>
                {{ action.icon }}
              </mat-icon>
              }
            </button>
          </span>
          }
          }
        </div>
      </td>
    </ng-container>

    
    @if(showExpandedRows) {
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
        <div class="table-detail-expand">
          <kzn-table [data]="row.expandedRowsData?.data" [columns]="row.expandedRowsData?.columns"
            [rowActions]="row.expandedRowsData?.actions ?? []" [showSearch]="false"
            [showPagination]="false"></kzn-table>
        </div>
      </td>
    </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      cdkDrag
      [cdkDragData]="row"
      [cdkDragDisabled]="!enableRowReorder"
      [cdkDragStartDelay]="enableRowReorder ? 80 : 0"
      cdkDragLockAxis="y"
      cdkDragBoundary=".table-container--reorderable"
      [class.table-row--draggable]="enableRowReorder"></tr>
    @if(showExpandedRows) {
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
      [ngClass]="expandedElement === row ? 'row-expanded' : 'row-collapsed'"></tr>
    }
   
  
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        {{ 'tableNoDataFilter' | translate }} "{{ showSearch ? activeFilterText : '' }}"
      </td>
    </tr>
  </table>
</div>
</div>
@if(showPagination) {
<mat-paginator (page)="scrollUp()" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
}
}